import React from 'react';
import { Box, Typography } from '@mui/material';
import { brand } from '../theme';

export function SectionHeader({ icon: Icon, title, subtitle }) {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
            <Box sx={{
                width: 38, height: 38, borderRadius: '50%', display: 'flex', alignItems: 'center',
                justifyContent: 'center', bgcolor: brand.primaryTint, color: brand.primary, flexShrink: 0,
            }}>
                <Icon fontSize="small" />
            </Box>
            <Box>
                <Typography sx={{ fontWeight: 700 }}>{title}</Typography>
                {subtitle && <Typography variant="caption" color="text.secondary">{subtitle}</Typography>}
            </Box>
        </Box>
    );
}

export default SectionHeader;
